import { createStore } from 'satcheljs';
export var mobileDeviceFullStore = createStore('mobileDeviceFullStore', {
    devices: [],
    selected: -1,
    isLoggingOpen: false,
    isDetailsOpen: false,
    notSendReadReceipt: true,
    isLoggingEnabled: false,
    isDevicesDirty: false,
    isLoggingEnabledDirty: false,
    isNotSendReadReceiptDirty: false,
    casMailbox: {},
    deviceStatistics: [],
});
//# sourceMappingURL=store.js.map